import React from "react";
import styled from "styled-components";

const DivStyled = styled.div`
    &.filter-tests{
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        width: 70vw;
        max-width: 1024px;
        margin: 2rem auto 24px;

        form {
            display: block;
            margin-top: 0em;
        }

        .filters {
            display: -webkit-box;
            display: flex;
            flex-wrap: wrap;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: justify;
            justify-content: space-between;
            margin-bottom: 2rem;
        }

        .item:last-child{
            margin-right: 8px;
        }

        .item:first-child{
            -webkit-box-flex: 1;
            flex: 1 0 25%;
        }

        .container-icon{
            position: relative;
        }

        .input {
            padding: .8rem 1rem;
            border: thin solid #66279b;
            font-size: 1.2rem;
            color: #66279b;
            // font-family: pantonregular;
        }

        .-alt{
            color: #505050;
            //font-family: pantonregular;
            padding: 24px 16px;
            border: none;
            // font-style: italic;
            width: 100%;
            font-size: 16px;
        }

        .-dropdown {
            position: relative;
            background: #fff;
        }

        .select{
            // -webkit-appearance: none;
            position: relative;
            z-index: 1;
            background: 0 0;
        }
    }
`;

export default (node: any) => {
    return (
        <DivStyled className="filter-tests">
            {node.children}
        </DivStyled>
    )
}